export default __webpack_public_path__ + "static/media/isb-icon.4a1e6412.webp";